import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { getWhatYouWantTitleById } from '@/pages/Onboarding/options/WhatYouWant/utils/getWhatYouWant';
import { WHAT_YOU_WANT_OPTIONS } from '@/pages/Onboarding/options/WhatYouWant/WHAT_YOU_WANT_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types.ts';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const WhatYouWantScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'WhatYouWant',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const whatYouWant = form.watch('what_you_want');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['what_you_want']>,
  ) => {
    form.setValue('what_you_want', option.id);
  };

  const handleNextStep = () => {
    const whatYouWantTitle = getWhatYouWantTitleById(whatYouWant);
    userService.createOrUpdate({
      onboarding_data: {
        what_you_want: whatYouWantTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What Do You Want From Him?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {WHAT_YOU_WANT_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={whatYouWant === option.id}
              control={form.control}
              option={option}
              name="what_you_want"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!whatYouWant}
      />
    </OnboardingPage>
  );
};
